var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',[_c('div',{staticClass:"main-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"flex flex-end clearfix"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])],1),_c('div',{staticClass:"detail-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }